import apiClient from "./apiClient";
import { apiUrl } from "../authconfig";

/** Same origin as other app APIs; from `apiUrl` in authconfig.js */
export const ADMIN_USER_API_BASE = apiUrl;

/**
 * @param {string} userEmail
 * @returns {Promise<{ isAdmin: boolean, data?: object, error?: string }>}
 */
export async function checkUserIsAdmin(userEmail) {
  const email = String(userEmail || "").trim();
  if (!email) {
    return { isAdmin: false, data: null, error: null };
  }

  try {
    const { data } = await apiClient.get(
      `${String(ADMIN_USER_API_BASE).replace(/\/$/, "")}/api/admin-user/check`,
      { params: { userEmail: email } }
    );
    return {
      isAdmin: Boolean(data?.isAdmin),
      data,
      error: null,
    };
  } catch (err) {
    const message =
      err?.response?.data?.error ||
      err?.response?.data?.message ||
      err?.message ||
      "Failed to verify admin access";
    return { isAdmin: false, data: null, error: message };
  }
}
